import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { captureFirstTouchAttribution } from "./utils/attributionCapture";
import { initMetaPixel } from "./services/metaPixel";
import { initGa4 } from "./services/ga4";
import { pingPageView } from "./services/pageViewTracking";
import AppErrorBoundary from "./components/shared/AppErrorBoundary";
import StaleClientRecovery from "./components/shared/StaleClientRecovery";
import ToastHost from "./components/shared/ToastHost";
import PushNotificationBootstrap from "./components/shared/PushNotificationBootstrap";
import PushRegistrationBanner from "./components/shared/PushRegistrationBanner";
import PushNotificationToast from "./components/shared/PushNotificationToast";
import PushNotificationNavigation from "./components/shared/PushNotificationNavigation";
import { PlatformConfigProvider } from "./context/PlatformConfigContext";
import { MessengerChatProvider } from "./context/MessengerChatContext";
import "./App.css";

function App() {
  useEffect(() => {
    captureFirstTouchAttribution();
    initMetaPixel();
    initGa4();
    pingPageView();
  }, []);

  return (
    <BrowserRouter>
      <AppErrorBoundary>
        <PlatformConfigProvider>
          <MessengerChatProvider>
            <div className="App">
              <StaleClientRecovery />
              <ToastHost />
            <PushNotificationBootstrap />
            <PushRegistrationBanner />
            <PushNotificationToast />
            <PushNotificationNavigation />
              <AppRoutes />
            </div>
          </MessengerChatProvider>
        </PlatformConfigProvider>
      </AppErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
